<div *ngIf="prikaziStranicu" class="container-fluid">
  <h2 class="content-block djelatnici-naslov">
    DJELATNICI
    <span [class.active]="popisAktivnih" (click)="dohvatiDjelatnike()">aktivni</span>
    <span>/</span>
    <span [class.active]="!popisAktivnih" (click)="dohvatiNeaktivneDjelatnike()">neaktivni</span>
  </h2>

  <div class="customTable popisDjelatnika m-40">
    <dx-data-grid
      [dataSource]="djelatnici"
      [wordWrapEnabled]="true"
      keyExpr="korisnickoIme"
      [showBorders]="false"
      [showColumnLines]="true"
      (onToolbarPreparing)="onToolbarPreparing($event)"
    >
      <div *dxTemplate="let data of 'naslovTablice'" class="grid-wrapper">
        <div class="naslov">
          <h2 class="mb-0" style="padding-right: 30px">Djelatnici</h2>
          <p class="mt-0">Popis svih djelatnika</p>
        </div>
        <dx-button
          [disabled]="pravaZaTrenutniPogled != 2"
          class="add-user"
          icon="plus"
          hint="Dodavanje djelatnika"
          stylingMode="outlined"
          type="success"
          (click)="dodajDjelatnikaPopup()"
        >
        </dx-button>

        <dx-button
          [disabled]="pravaZaTrenutniPogled != 2"
          class="rights-of-users"
          icon="key"
          hint="Dodjeljivanje prava korisnika"
          stylingMode="outlined"
          type="success"
          (onClick)="djelatniciPrava()"
        >
        </dx-button>
        
        <div class="d-inline ml-15" style="max-width: 200px;">
          <dx-file-uploader
            [disabled]="pravaZaTrenutniPogled != 2"
            selectButtonText="Uvoz iz excela"
            labelText=""
            accept=".xls,.xlsx"
            uploadMode="instantly"
            [uploadUrl]="upload_URL"
            (onUploaded)="onUploaded($event)"
          >
          </dx-file-uploader>
        </div>
      </div>

      <div *dxTemplate="let data of 'gumb_ispis'">
        <div class="selectDropdown">
          <dx-button *ngIf="prikaziGumb" icon="print" hint="Ispiši" (click)="ispisi()"></dx-button>
        </div>
      </div>

      <dxo-search-panel
        [visible]="true"
        [width]="180"
        placeholder="Pretraži..."
      >
      </dxo-search-panel>

      <dxo-export [enabled]="dozvoli_export" fileName="djelatnici"></dxo-export>

      <dxo-paging [enabled]="true" [pageSize]="15"></dxo-paging>

      <dxo-pager
        [showPageSizeSelector]="true"
        [allowedPageSizes]="[15, 30, 45]"
        [showInfo]="true"
      >
      </dxo-pager>

      <dxi-column
        dataField="idDjelatnik"
        caption="ID"
        [width]="80"
      ></dxi-column>
      <dxi-column
        dataField="korisnickoIme"
        caption="Korisničko ime"
        [minWidth]="300"
      ></dxi-column>
      <dxi-column dataField="ime" caption="Ime" [minWidth]="100"></dxi-column>
      <dxi-column dataField="oib" caption="OIB" [width]="150"></dxi-column>
      <dxi-column
        dataField="cijenaRadaPrikaz"
        caption="Cijena satnice"
        [width]="150"
        alignment="right"
      ></dxi-column>
      <dxi-column
        dataField="email"
        caption="Email"
        [minWidth]="150"
        [visible]="false"
      ></dxi-column>
      <dxi-column
        dataField="organNaziv"
        caption="Organ"
        [minWidth]="200"
      ></dxi-column>
      <dxi-column
        dataField="napomena"
        caption="Napomena"
        [minWidth]="200"
      ></dxi-column>
      <dxi-column cellTemplate="uredjivanje" alignment="center" [width]="110" [fixed]="true" fixedPosition="right">
        <div *dxTemplate="let data of 'uredjivanje'">
          <dx-button
            [disabled]="pravaZaTrenutniPogled != 2"
            icon="edit"
            hint="Uredi"
            (onClick)="urediDjelatnikaPopup(data)"
          >
          </dx-button>
          <dx-button
            [disabled]="pravaZaTrenutniPogled != 2"
            *ngIf="popisAktivnih"
            icon="trash"
            hint="Brisanje djelatnika"
            (onClick)="obrisiDjelatnikaPopup(data)"
          >
          </dx-button>
        </div>
      </dxi-column>
    </dx-data-grid>
  </div>
</div>

<!-- POPUPS -->
<dx-popup
  [width]="800"
  [height]="'auto'"
  [showTitle]="true"
  title="{{ djelatnikFormaPoruka }}"
  [dragEnabled]="true"
  [closeOnOutsideClick]="true"
  [position]="{ my: 'top', at: 'center top', of: '', offset: '0 150' }"
  [(visible)]="djelatnikPopupVisible"
>
  <div class="popup-form-wrapper">
    <div class="floating-placeholder">
      <dx-text-box
        placeholder="Ime i prezime"
        [value]="ime"
        (onValueChanged)="onChangeIme($event)"
      ></dx-text-box>
    </div>
    <div class="floating-placeholder">
      <dx-text-box
        placeholder="OIB"
        [value]="oib"
        (onValueChanged)="onChangeOIB($event)"
      >
      </dx-text-box>
    </div>
    <div class="floating-placeholder">
      <dx-text-box
        [readOnly]="djelatnikFormaPoruka === 'Uređivanje!'"
        placeholder="Korisničko ime"
        [value]="korisnickoIme"
        (onValueChanged)="onChangeKorisnickoIme($event)"
      ></dx-text-box>
    </div>
    <div class="floating-placeholder">
      <dx-text-box
        placeholder="Lozinka"
        [value]="lozinka"
        (onValueChanged)="onChangeLozinka($event)"
      ></dx-text-box>
    </div>
    <div class="floating-placeholder">
      <dx-text-box
        placeholder="Email"
        [value]="email"
        (onValueChanged)="onChangeEmail($event)"
      >
      </dx-text-box>
    </div>
    <div class="floating-placeholder">
      <dx-select-box
        [dataSource]="status"
        displayExpr="naziv"
        valueExpr="id"
        placeholder="Status"
        [value]="aktivan === 'Y' ? 1 : 0"
        (onValueChanged)="onChangeStatus($event)"
      >
      </dx-select-box>
    </div>
    <!-- <div class="floating-placeholder">
      <dx-select-box 
          [dataSource]="admin"
          displayExpr="naziv"
          valueExpr="id"
          placeholder="Admin"
          [value]="adminStatus === 'Da' ? 1 : 0"
          (onValueChanged)="onChangeAdmin($event)">
      </dx-select-box>
    </div> -->
    <!-- <div class="floating-placeholder">
      <dx-select-box 
          [dataSource]="vrsta"
          displayExpr="naziv"
          valueExpr="id"
          placeholder="Vrsta"
          [value]="vrstaStatus"
          (onValueChanged)="onChangeVrsta($event)">
      </dx-select-box>
    </div> -->
    <div class="floating-placeholder">
      <dx-select-box
        [dataSource]="organi"
        displayExpr="naziv"
        valueExpr="sifra"
        placeholder="Organ"
        [value]="organ"
        (onValueChanged)="onChangeOrgan($event)"
      >
      </dx-select-box>
    </div>
    <div class="floating-placeholder">
      <dx-number-box
        [value]="cijenaRada"
        placeholder="Cijena rada po satu (kn)"
        (onValueChanged)="onChangeCijenaRada($event)"
      >
      </dx-number-box>
    </div>
    <div class="floating-placeholder">
      <dx-check-box
        text="Rukovodeći"
        [value]="rukovodeci"
        (onValueChanged)="changeRukovodeci($event)"
      ></dx-check-box>
    </div>
    <div class="floating-placeholder" style="grid-column: 1 / span 2">
      <dx-text-area
        placeholder="Napomena"
        [value]="napomena"
        (onValueChanged)="onChangeNapomena($event)"
      >
      </dx-text-area>
    </div>
    <!-- <div class="floating-placeholder">
        <dx-select-box 
            [dataSource]="radnaMjesta"
            displayExpr="naziv"
            valueExpr="id"
            placeholder="Radno mjesto"
            [value]="radnoMjesto"
            (onValueChanged)="onChangeRadnoMjesto($event)">
        </dx-select-box>
    </div> -->
    <!-- <div class="floating-placeholder">
        <dx-select-box 
            [dataSource]="partneri"
            displayExpr="naziv"
            valueExpr="id"
            placeholder="Partner"
            [value]="partnerId"
            [searchEnabled]="true"
            [searchExpr]="'naziv'"
            (onValueChanged)="onChangePartner($event)">
        </dx-select-box>
    </div> -->
    <!-- <div class="floating-placeholder">
        <dx-select-box 
            [dataSource]="poslovnice"
            displayExpr="naziv"
            valueExpr="id"
            placeholder="Poslovnica"
            [value]="poslovnicaId"
            [searchEnabled]="true"
            [searchExpr]="'naziv'"
            (onValueChanged)="onChangePoslovnica($event)">
        </dx-select-box>
    </div> -->
  </div>

  <dx-button
    *ngIf="djelatnikFormaPoruka === 'Dodavanje!'"
    class="dodajButton"
    stylingMode="outlined"
    [disabled]="korisnickoIme.length < 1"
    type="success"
    text="Dodaj"
    (onClick)="dodajDjelatnika()"
  >
  </dx-button>
  <dx-button
    *ngIf="djelatnikFormaPoruka === 'Uređivanje!'"
    class="dodajButton"
    stylingMode="outlined"
    type="success"
    text="Uredi"
    (onClick)="urediDjelatnika()"
  >
  </dx-button>

  <dx-button
    *ngIf="djelatnikFormaPoruka === 'Uređivanje!'"
    class="urediPravoButton"
    stylingMode="outlined"
    style="margin-top: 30px"
    type="success"
    text="Grupe djelatnika"
    (onClick)="urediPravoDjelatnikaPopup()"
  >
  </dx-button>
</dx-popup>

<dx-popup
  [width]="500"
  [height]="'auto'"
  [showTitle]="true"
  title="Promjena grupe djelatnika"
  [dragEnabled]="false"
  [showCloseButton]="true"
  [(visible)]="popupVisible"
  [closeOnOutsideClick]="false"
>
  <div *dxTemplate="let data of 'naslovTablice'"></div>
  <dx-data-grid
    [dataSource]="sveKorisnickeGrupe"
    [showColumnLines]="true"
    [wordWrapEnabled]="true"
    [showBorders]="false"
  >
    <dxi-column
      dataField="grupakor"
      caption="Prava"
      cellTemplate="templatePrava"
    ></dxi-column>
    <div *dxTemplate="let data of 'templatePrava'">
      <dx-check-box
        displayExpr="sgr_naziv"
        [value]="data.data.grupakor"
        (onValueChanged)="editGrupe($event, data)"
      >
      </dx-check-box>
    </div>
    <dxi-column dataField="sgr_naziv" caption="Naziv grupe"></dxi-column>
  </dx-data-grid>
</dx-popup>

<dx-popup
  [width]="400"
  [height]="'auto'"
  [showTitle]="true"
  title="Brisanje!"
  [dragEnabled]="false"
  [closeOnOutsideClick]="false"
  [position]="{ my: 'top', at: 'center top', of: '', offset: '0 150' }"
  [(visible)]="obrisiDjelatnikaPopupVisible"
>
  <p>Jeste li sigurni da želite obrisati djelatnika sa popisa?</p>
  <dx-button
    class="dodajButton"
    stylingMode="outlined"
    type="success"
    text="DA"
    (onClick)="obrisiDjelatnika()"
  >
  </dx-button>
  <dx-button
    class="dodajButton"
    stylingMode="outlined"
    type="danger"
    text="NE"
    (onClick)="obrisiDjelatnikaPopupVisible = false"
  >
  </dx-button>
</dx-popup>
